import styled from 'styled-components';
import { breakpoints } from '../../utils/breakpoints';

export const Container = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  flex-direction: column;
  padding: 0 ${({width}) => width >  parseInt(breakpoints.xs) ? '10%' : '16px'};
  padding-bottom: 28px;

  > h1 {
    font-size: ${({width}) => width > parseInt(breakpoints.xs) ? '32px' : '24px'};
    font-weight: 600;
    margin: 24px 0;
    font-family: "Biennale Regular";
  }

  > p {
    font-size: ${({width}) => width > parseInt(breakpoints.xs) ? '18px' : '14px'};
    margin: 8px 0 40px;
    color: '#A191FF';
    }

     strong {
      color: '#A191FF';
    }
`;
